/**
 * Define sell-micro-app warning message based on code.
 */
export class SellWarnings {

  static F_REMPLT_AIS_ONH = 'The offer you have selected is not currently the highest. Select <br><strong>Continue</strong> to proceed with this offer or <strong>Cancel</strong> to  go back.';
  static F_REMPLT_AIS_NAC = 'You can\'t take action on this vehicle because it is no longer in active status.';
    
  static warningMap = new Map ([

    ['F-REMPLT-AIS-ONH', SellWarnings.F_REMPLT_AIS_ONH]
        
  ]);

  static getwarningMessage (error: string) {
    return SellWarnings.warningMap.get(error);       
  }
    
}
